module.exports = __webpack_public_path__ + "img/jianshiqi.a75ca4a3.jpg";